import { cleanParams, toQueryParams } from "helpers/url"
import appAxios from "./axios"
class CitiesService {
    getAll(countryID: string) {        
        return appAxios.get(`/cities?` + toQueryParams(cleanParams({countryID})))
    }
}
export const citiesService = new CitiesService()